// extracted by mini-css-extract-plugin
export default {"logo":"TitleCard_logo__GJP6c","title":"TitleCard_title__4Pw1M"};